import { IUpdateItemProcessoRiscosUseCase } from "../../../presentation/useCases/update/updade_item_processo_riscos_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// UpdateProcessoRiscosUseCase


export class UpdateItemProcessoRiscosUseCase implements IUpdateItemProcessoRiscosUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async updateItemProcessoRiscos(IdItemProcesso: number, IdProcesso: number, Descricao: string, IdFuncionarioResp: number | null,
  IdFuncionarioCoresp: number | null, DataAtualizacao: Date | null, Observacao: string | null): Promise<void> {
    
    await this.repository.updateItemProcessoRiscos(IdItemProcesso, IdProcesso, Descricao, IdFuncionarioResp, IdFuncionarioCoresp, DataAtualizacao, Observacao);
  }
}
